import type { RouterConfig } from '@nuxt/schema';

// https://router.vuejs.org/api/#routeroptions
export default <RouterConfig>{
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      };
    }
    if (to === from) {
      return {
        left: 0,
        top: 0,
        behavior: 'smooth'
      };
    }

    return new Promise((resolve) => {
      if (!savedPosition) {
        resolve({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
      if (!!savedPosition) {
        setTimeout(() => {
          resolve({
            left: savedPosition?.left || 0,
            top: savedPosition?.top || 0,
            behavior: 'smooth'
          });
        }, 300);
      }
    });
  }
};
